
import { defineComponent, PropType } from 'vue'

import {
  Analyzer,
  AnalyzerConnection,
  IssueOccurrenceFrequency,
  Maybe,
  Run,
  RunConnection,
  VcsProviderChoices
} from '~/types/types'
import { resolveNodes } from '~/utils/array'
import { shortenLargeNumber } from '~/utils/string'

export default defineComponent({
  name: 'MetadataViewMobile',
  data() {
    return {
      metadataTextEntries: [
        'Analysis status',
        'Source',
        'Active issues',
        'Issues prevented',
        'Default branch',
        'Analyzers'
      ]
    }
  },
  props: {
    isActivated: {
      type: Boolean,
      default: false
    },
    defaultBranchName: {
      type: String,
      default: ''
    },
    availableAnalyzers: {
      type: Object as PropType<Maybe<AnalyzerConnection>>,
      default: null
    },
    vcsProvider: {
      type: String as PropType<VcsProviderChoices>,
      default: ''
    },
    latestAnalysisRun: {
      type: Object as PropType<Maybe<Run>>,
      default: null
    },
    runs: {
      type: Object as PropType<Maybe<RunConnection>>,
      default: {}
    },
    issuesPrevented: {
      type: [String, Number] as PropType<string | number>,
      default: ''
    },
    issueOccurrenceDistributionByIssueType: {
      type: Array as PropType<Array<IssueOccurrenceFrequency>>,
      default: () => []
    },
    /** Whether to show the "Last knowledge sync" row (viewer has Knowledge access + feature). */
    showKnowledgeSync: {
      type: Boolean,
      default: false
    },
    /** Relative time of the last knowledge sync, e.g. "2 days ago" ("Never" when unsynced). */
    lastKnowledgeSync: {
      type: String,
      default: 'Never'
    }
  },
  computed: {
    analyzers(): Array<Analyzer> {
      return resolveNodes(this.availableAnalyzers)
    },
    totalIssueCount(): string | number {
      const distributionEntries = this.issueOccurrenceDistributionByIssueType?.find(
        ({ key }) => key === 'all'
      )
      return shortenLargeNumber(distributionEntries?.count as number) || 0
    },
    othersList() {
      const initialListCount = 4
      return this.analyzers.slice(initialListCount)
    },
    initialList() {
      const initialListCount = 4
      return this.analyzers.slice(0, initialListCount)
    },
    vcsProviderIcon() {
      return this.$providerMetaMap[this.vcsProvider]?.icon ?? ''
    },
    vcsProviderText() {
      return this.$providerMetaMap[this.vcsProvider]?.text ?? ''
    }
  }
})
